export const DEMO_CTA_URL = "/contact";

export const DEMO_CTA_LABEL = "Request early access →";
